import React from 'react';
import {
  HiddenContent,
  SideNavButtonInnerWrapper,
  SideNavLinkOuterWrapper,
  SideNavLinkTitleWrapper,
  SvgWrapper,
} from '../styles';
import { SvgIcon } from 'src/commons/components/SvgIcon/SvgIcon';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { ToolbarItem } from '@amzn/aac-chrome-internal-api';

interface SideNavAllToolsButtonProps {
  toolbarItem: ToolbarItem;
  onMouseEnter: (e) => void;
  onMouseLeave: (e) => void;
}

const AllToolsIcon: React.VFC<{ toolbarItem: ToolbarItem }> = ({
  toolbarItem,
}) => {
  return (
    <SvgWrapper
      isSelected={false}
      data-ccx-e2e-id={toolbarItem.id}
      alignItems="center"
      justifyContent="center"
    >
      <SvgIcon
        iconPath={
          'https://m.media-amazon.com/images/G/01/CCX/svg/AllTools-light.svg'
        }
        ariaLabel={toolbarItem.toolTip}
        isSelected={false}
      />
    </SvgWrapper>
  );
};

const AllToolsHiddenContent: React.VFC<{
  toolTip: string;
  isAllToolsOpen: boolean;
}> = ({ toolTip, isAllToolsOpen }) => {
  return (
    <HiddenContent alignItems="center" justifyContent="space-between">
      <SideNavLinkTitleWrapper
        isAllToolsOpen={isAllToolsOpen}
        isFromAllTools={true}
      >
        {toolTip}
      </SideNavLinkTitleWrapper>
    </HiddenContent>
  );
};

const SideNavAllToolsButton: React.VFC<SideNavAllToolsButtonProps> = ({
  toolbarItem,
  onMouseEnter,
  onMouseLeave,
}) => {
  const { isNavOpen, isAllToolsOpen, setIsAllToolsOpen } =
    useConsolidatedNavContext();

  return (
    <SideNavLinkOuterWrapper
      isSelected={false}
      onFocus={() => {
        if (!isAllToolsOpen) {
          setIsAllToolsOpen(true);
        }
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <SideNavButtonInnerWrapper
        isNavOpen={isNavOpen}
        isSelected={false}
        data-ccx-e2e-id={toolbarItem.id}
        aria-label={toolbarItem.toolTip}
        {...getTaktAttributes(toolbarItem.id, chromeComponents.NAV, {
          url: '',
        })}
      >
        <AllToolsIcon toolbarItem={toolbarItem} />
        <AllToolsHiddenContent
          toolTip={toolbarItem.toolTip}
          isAllToolsOpen={isAllToolsOpen}
        />
      </SideNavButtonInnerWrapper>
    </SideNavLinkOuterWrapper>
  );
};

export default SideNavAllToolsButton;
